/**
 * Application constants
 */

// Default currency exchange rates (fallback values)
export const DEFAULT_CURRENCY_RATES = {
  USD: 2.75,
  EUR: 3.00,
};

// Default USD to GEL rate
export const DEFAULT_USD_GEL_RATE = 2.75;

// Default EUR to GEL rate  
export const DEFAULT_EUR_GEL_RATE = 3.00;
